import { useState, useEffect } from "react";

import appData from "../data/appData.json";
import useHashLocation from "../use-hash-location";

export const useLevel = () => {
  const [location] = useHashLocation();
  const [currentLevel, setCurrentLevel] = useState(0);
  const [currentRouteId, setCurrentRouteId] = useState("");
  const [parentRouteId, setParentRouteId] = useState("");

  useEffect(() => {
    const route = location.slice(1).split("/");

    const currentLevel = location == "/" ? 0 : route.length;
    const currentRoute = route.length > 0 ? route[route.length - 1] : "";
    const parentRoute = route.length > 1 ? route[route.length - 2] : "";

    setCurrentLevel(currentLevel);
    setCurrentRouteId(currentRoute);
    setParentRouteId(parentRoute);
  }, [location]);

  return [currentLevel, currentRouteId, parentRouteId];
};

export default useLevel;
